import type { Patient, Reference } from '@medplum/fhirtypes'
import { useContext } from 'react'
import { CurrentParticipantContext } from '#src/contexts/current-participant/CurrentParticipantContext.tsx'
import { ParticipantReferenceContext } from '#src/contexts/current-participant/ParticipantReferenceContext.tsx'
import { useMemoValue } from '#src/hooks/useMemoValue.ts'

export const useOptionalParticipantReference = ():
  | Reference<Patient>
  | undefined => {
  const participantReference = useContext(ParticipantReferenceContext)
  const currentParticipant = useContext(CurrentParticipantContext)

  /* `currentParticipant.reference` creates a new Reference object on every call
   * (createReference), so memoize by value — otherwise consumers that key memo
   * deps on it (e.g. useFileHandler → the TipTap extension array) rebuild on
   * every render, reconfiguring the editor on each keystroke. */
  return useMemoValue(participantReference ?? currentParticipant?.reference)
}
